import { styled } from '@mui/material';
import { ONVISTA_HOME } from '../../src/helpers/urlConstants';
import { Link } from '../Link';
import { colors } from '../../plugins/material-ui/themes/onvistaTheme';
import { ContactEmail, ContactPhone } from './Contacts';

const Logo = styled('img')(({ theme }) => ({
  height: '60px',
  [theme.breakpoints.down('sm')]: {
    height: '50px',
  },
}));

const LogoContainer = styled('div')(({ theme }) => ({
  paddingTop: theme.spacing(),
  paddingBottom: theme.spacing(),
}));

const HeaderGrid = styled('div')(({ theme }) => ({
  display: 'flex',
  padding: `0 ${theme.spacing(2)}`,
  justifyContent: 'space-between',
  alignItems: 'center',
  [theme.breakpoints.down('md')]: {
    padding: `${theme.spacing(0)} ${theme.spacing(2)}`,
    boxShadow: theme.shadows[2],
    alignItems: 'center',
  },
}));

const HeaderRight = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  '& > :not(style)': {
    marginLeft: theme.spacing(6),
    [theme.breakpoints.down('md')]: {
      marginLeft: theme.spacing(2),
    },
  },
}));

const HeaderItemWrapper = styled('div')(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    display: 'none',
  },
}));

const HeaderLink = styled(Link)(({ theme }) => ({
  fontFamily: 'Biryani,"Zilla Slab"',
  fontWeight: 800,
  letterSpacing: '0.5px',
  color: colors.ovMagenta,
  textDecoration: 'none',
  backgroundColor: 'none',
  [theme.breakpoints.down('lg')]: {
    display: 'none',
  },
}));

export const Header = () => {
  return (
    <>
      <HeaderGrid>
        <LogoContainer>
          <Logo src="/images/onvista/onvista-cashback-logo-new.svg" loading="lazy" />
        </LogoContainer>

        <HeaderRight>
          <HeaderLink href={ONVISTA_HOME} underline="none" variant="subtitle2">
            onvista.de
          </HeaderLink>
          <HeaderItemWrapper>
            <ContactPhone />
          </HeaderItemWrapper>
          <HeaderItemWrapper>
            <ContactEmail />
          </HeaderItemWrapper>
        </HeaderRight>
      </HeaderGrid>
    </>
  );
};
